import { mapKeys } from 'lodash'

export const mapAggregateProperties = (properties) => {
  if (!properties) return []
  const totalAggregateProperties = properties.map((property) => {
    return {
      ...property,
      name: `Total ${property.name}`
    }
  })

  return [
    ...totalAggregateProperties,
    { name: 'Location count', type: 'text' },
    { name: 'Name', type: 'text' }
  ]
}

export const mapAggregateH3FeatureProperties = (feature) => {
  const { count, hexBoundaryId, ...rest } = feature.properties || {}
  const properties = mapKeys(rest, (value, key) => {
    return `Total ${key}`
  })

  properties['Location count'] = count
  properties['Name'] = hexBoundaryId

  return { ...feature, properties }
}
